import AsyncStorage from "@react-native-async-storage/async-storage";
import { getStorybook } from "@sherlo/react-native-storybook";
import { view } from "./storybook.requires";

import { LogBox, Platform } from "react-native";
// LogBox.ignoreLogs(['Warning: ...']); // Ignore log notification by message
LogBox.ignoreAllLogs(); //Ignore all log notifications

let StorybookUIRoot = null;

if (Platform.OS === "web") {
    StorybookUIRoot = view.getStorybookUI({
        storage: AsyncStorage,
    });
} else {
    StorybookUIRoot = getStorybook(view, {
        storage: AsyncStorage,
    });
}

export default StorybookUIRoot;
